// Shared visual treatment; page-specific sizing and cell renderers remain intact.
const customDataGridStyles = {
  border: 0,
  borderRadius: "0 0 7px 7px",
  "&& .MuiDataGrid-topContainer, && .MuiDataGrid-columnHeaders": {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  fontFamily: "inherit",
  fontSize: 14,
  color: "#142b60",
  backgroundColor: "#fff",
  "--DataGrid-containerBackground": "#fff",
  "&& .MuiDataGrid-virtualScroller, && .MuiDataGrid-overlay, && .MuiDataGrid-filler":
    { backgroundColor: "#fff" },
  "&& .MuiDataGrid-columnHeaders": {
    background: "#e7efff !important",
    borderBottom: "1px solid #e0e9fa",
  },
  "&& .MuiDataGrid-columnHeader, && .MuiDataGrid-columnHeader--sortable, && .MuiDataGrid-columnHeaders .MuiDataGrid-filler":
    { background: "#e7efff !important", color: "#102454" },
  "&& .MuiDataGrid-columnHeader": { paddingLeft: "18px", paddingRight: "18px" },
  "&& .MuiDataGrid-columnHeaderTitle": {
    color: "#102454",
    fontFamily: "inherit",
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 0,
    textTransform: "none",
  },
  "&& .MuiDataGrid-columnSeparator": { color: "#f7faff" },
  "&& .MuiDataGrid-sortButton, && .MuiDataGrid-iconButtonContainer": {
    display: "inline-flex",
    color: "#64799b",
  },
  "&& .MuiDataGrid-sortIcon": { color: "#64799b" },
  "&& .MuiDataGrid-row": { backgroundColor: "#fff" },
  "&& .MuiDataGrid-row:hover": { backgroundColor: "#edf4ff" },
  "&& .MuiDataGrid-row.Mui-selected": { backgroundColor: "#e5efff" },
  "&& .MuiDataGrid-row.Mui-selected:hover": { backgroundColor: "#dce9ff" },
  "&& .MuiDataGrid-cell": {
    display: "flex",
    alignItems: "center",
    paddingTop: "8px",
    paddingBottom: "8px",
    borderColor: "#e4ebf8",
    color: "#142b60",
    fontFamily: "inherit",
    fontSize: 14,
    paddingLeft: "18px",
    paddingRight: "18px",
  },
  "&& .MuiDataGrid-cell small": {
    display: "block",
    color: "#536b91",
    fontSize: 11,
  },
  "&& .MuiCheckbox-root": { color: "#9baecb" },
  "&& .MuiCheckbox-root.Mui-checked, && .MuiCheckbox-root.MuiCheckbox-indeterminate":
    { color: "#0057ff" },
  '&& .MuiDataGrid-cell .badge, && .MuiDataGrid-cell [class*="status-pill"]': {
    borderRadius: "7px",
    padding: "6px 10px",
    fontSize: 13,
    fontWeight: 500,
    lineHeight: "20px",
  },
  "&& .MuiDataGrid-cell .progress": {
    height: 8,
    borderRadius: "99px",
    backgroundColor: "#dfe6f2",
  },
  "&& .MuiDataGrid-cell .progress-bar": { borderRadius: "99px" },
  "&& .MuiDataGrid-footerContainer": {
    background: "#fcfdff",
    borderTop: "1px solid #e0e9fa",
    minHeight: 72,
    padding: "10px 22px",
    color: "#52698e",
    flexWrap: "wrap",
    gap: 1.5,
  },
  "&& .MuiDataGrid-footerContainer .MuiTypography-root": {
    fontFamily: "inherit",
    fontSize: 14,
    color: "#233d6b",
  },
  "&& .MuiDataGrid-footerContainer .MuiInputBase-root": {
    borderRadius: "8px",
    background: "#fff",
    minHeight: 42,
    fontFamily: "inherit",
    color: "#233d6b",
  },
  "&& .MuiDataGrid-footerContainer .MuiOutlinedInput-notchedOutline": {
    borderColor: "#d8e4fa",
  },
  "&& .MuiPaginationItem-root": {
    fontFamily: "inherit",
    fontSize: 14,
    fontWeight: 600,
    color: "#142b60",
    minWidth: 36,
    height: 36,
    borderRadius: "7px",
  },
  "&& .MuiPaginationItem-root.Mui-selected": {
    color: "#fff",
    backgroundColor: "#0057ff",
    boxShadow: "0 3px 8px #0057ff20",
  },
  "&& .MuiPaginationItem-root.Mui-selected:hover": {
    backgroundColor: "#0049db",
  },
};

export default customDataGridStyles;
